import { render, staticRenderFns } from "./assignment-list.vue?vue&type=template&id=c6684ca0&"
import script from "./assignment-list.vue?vue&type=script&lang=ts&"
export * from "./assignment-list.vue?vue&type=script&lang=ts&"
import style0 from "./assignment-list.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports